module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_3016.6ff866d9.png";